import { AccredibleBaseSelectInputComponentModule } from '@accredible-frontend-v2/components/base-components/base-select-input';
import { AccredibleTruncatePipeModule } from '@accredible-frontend-v2/pipes/truncate';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { TranslocoModule } from '@jsverse/transloco';
import { AccredibleSearchInputComponent } from './search-input.component';

const MATERIAL_MODULES = [MatInputModule, MatButtonModule];

@NgModule({
  imports: [
    CommonModule,
    AccredibleBaseSelectInputComponentModule,
    AccredibleTruncatePipeModule,
    TranslocoModule,
    ...MATERIAL_MODULES,
  ],
  declarations: [AccredibleSearchInputComponent],
  exports: [AccredibleSearchInputComponent],
})
export class AccredibleSearchInputComponentModule {}
